/**
 * SceneFactory — maps a topology definition to a scene layout.
 */

import type { SceneLayout, TopologyInfo } from "./SceneLayout.js";
import { starLayout } from "./StarScene.js";
import { pipelineLayout } from "./PipelineScene.js";
import { hierarchicalLayout } from "./HierarchicalScene.js";
import { meshLayout } from "./MeshScene.js";
import { mapReduceLayout, isMapReducePattern } from "./MapReduceScene.js";
import { debateLayout, isDebatePattern } from "./DebateScene.js";

/** Create a scene layout from topology info. */
export function createSceneLayout(topo: TopologyInfo): SceneLayout {
  switch (topo.type) {
    case "star":
      return starLayout(topo);
    case "pipeline":
      return pipelineLayout(topo);
    case "hierarchical":
      return hierarchicalLayout(topo);
    case "mesh":
      return meshLayout(topo);
    case "peer-to-peer":
      return meshLayout(topo);
    case "custom": {
      // Detect specific patterns from edge structure
      if (isDebatePattern(topo)) return debateLayout(topo);
      if (isMapReducePattern(topo)) return mapReduceLayout(topo);
      return meshLayout(topo); // Fallback
    }
    default:
      return meshLayout(topo);
  }
}
